// The page the visitor actually asked for. `components/RequireAuth.tsx` puts
// the full in-app location in the router's `state.from` when it bounces a
// visitor to /login or /mfa-required, so finishing that gate can put them back
// on it — path, query string AND fragment — instead of dropping everyone on the
// dashboard. That is what keeps a shared deep link (`/designer/{workflowId}`,
// `/runs?workflowId=…&runId=…`) whole across sign-in and the MFA challenge.
//
// The router's own captured location is the ONLY accepted source: nothing here
// reads the request, so a `?returnUrl=` pasted onto /login is ignored and this
// can never become an open redirect. The shape check is belt-and-braces for the
// same reason — anything that isn't a single-slash in-app path falls back to /.
interface CapturedPage {
  pathname?: unknown;
  search?: unknown;
  hash?: unknown;
}

export function capturedReturnTo(routerState: unknown): string {
  const from = (routerState as { from?: CapturedPage } | null | undefined)?.from;
  const pathname = typeof from?.pathname === 'string' ? from.pathname : '';
  // `//host/path` is protocol-relative, i.e. off-site — not an in-app location.
  if (!pathname.startsWith('/') || pathname.startsWith('//')) {
    return '/';
  }
  const search = typeof from?.search === 'string' ? from.search : '';
  const hash = typeof from?.hash === 'string' ? from.hash : '';
  return `${pathname}${search}${hash}`;
}
